import AbstractRestApi from '@/api/RestApi/AbstractRestApi'

class CompanyAllowedMeals extends AbstractRestApi {
    getBaseUrl() {
        return '/api/v1/company-restaurant-allowed-meals'
    }
}

export default new CompanyAllowedMeals()
